const BICardUpData =[
    {
        card1up1:"AMAZON",
        cardsaleinfo:'60% sales are genrated here',
        card1dnP:"BEST ONLINE PLATEFORM"
    },
    {
        card1up1:"ELECTRONICS",
        cardsaleinfo:'80% order received',
        card1dnP:"BEST CATEGORY"
    },
    {
        card1up1:"NAME OF THE WAREHOUSE IN 2 LINES",
        cardsaleinfo:'80% order received',
        card1dnP:"BEST WAREHOUSE"
    },
    {
        card1up1:"DEPARTMENT 2",
        cardsaleinfo:'10 employees got promotions',
        card1dnP:"BEST DEPARTMENT"
    },
]

export { BICardUpData }